import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import CompetitionTypePill from './CompetitionTypePill';
import CompetitionModePill from './CompetitionModePill';
import CompetitionVisibilityPill from './CompetitionVisibilityPill';
import CompetitionPrizePill from './CompetitionPrizePill';
import { CompetitionSummary } from '../../types/interfaces';
import { formatDate } from '../../utils/dates';

interface JoinedCompetitionCardProps {
  competition: CompetitionSummary;
}

const JoinedCompetitionCard: React.FC<JoinedCompetitionCardProps> = ({ competition }) => {
  const statusClass = (competition.status || 'default').toLowerCase().replace(/\s+/g, '-');
  const formattedEndDate = formatDate(competition.end_date);
  const hasSubmission = Boolean(competition.latest_version);

  return (
    <div className="joined-card">
      <div className="joined-card__header">
        {competition.logo_path && (
          <img
            src={`${competition.logo_path}`}
            alt={`${competition.title} logo`}
            className="joined-card__logo"
          />
        )}
        <div className="joined-card__title-group">
          <h4>{competition.title}</h4>
          <div className="competition-card__badges">
            <span className={`dashboard__competition-status dashboard__competition-status--${statusClass}`}>
              {competition.status}
            </span>
            <CompetitionTypePill type={competition.type} />
            <CompetitionModePill mode={competition.competition_mode} />
            <CompetitionVisibilityPill visibility={competition.visibility} />
            <CompetitionPrizePill prize={competition.prize} />
          </div>
        </div>
      </div>
      <div className="joined-card__meta">
        <div>
          <span className="joined-card__meta-label">Ends</span>
          <span className="joined-card__meta-value">{formattedEndDate}</span>
        </div>
        <div>
          <span className="joined-card__meta-label">Submissions Allowed</span>
          <span className="joined-card__meta-value">{competition.number_of_submissions}</span>
        </div>
        <div>
          <span className="joined-card__meta-label">Latest Version</span>
          <span className="joined-card__meta-value">
            {hasSubmission ? (
              <>
                v{competition.latest_version}{' '}
                <Link to={`/submission/${competition.competition_id}`} className="joined-card__submission-link">
                  (view)
                </Link>
              </>
            ) : (
              <span style={{ color: 'var(--text-secondary)', fontWeight: 500 }}>- (no submission yet)</span>
            )}
          </span>
        </div>
        {competition.competition_mode === 'team' && (
          <div>
            <span className="joined-card__meta-label">Team</span>
            <span className="joined-card__meta-value">
              {competition.team_name ? (
                <>
                  {competition.team_name}
                  {competition.is_team_lead ? ' (lead)' : ''}
                </>
              ) : (
                <span style={{ color: 'var(--text-secondary)', fontWeight: 500 }}>- not assigned yet</span>
              )}
            </span>
          </div>
        )}
      </div>
      <div className="joined-card__meta-label">
        <Button variant="outline" size="sm" onClick={() => window.location.href = `/competition/${competition.competition_id}`}>
          Open
        </Button>
      </div>
    </div>
  );
};

export default JoinedCompetitionCard;
